import { memo } from 'react';
import { useWatch } from 'react-hook-form';
import { OrderFormData } from '../order_schema';
import { MarketForm } from './market';
import { LimitForm } from './limit';
import { StopLimitForm } from './stop_limit';
import { StopMarketForm } from './stop_market';
import { OrderType } from '@/feature/order_entry/order_types';

export const OrderTypeFormRenderer = memo(() => {
  const orderType = useWatch<OrderFormData>({ name: 'orderType' });

  switch (orderType) {
    case OrderType.market:
      return <MarketForm />;
    case OrderType.limit:
      return <LimitForm />;
    case OrderType.stopLimit:
      return <StopLimitForm />;
    case OrderType.stopMarket:
      return <StopMarketForm />;
    default:
      return null;
  }
});

OrderTypeFormRenderer.displayName = 'OrderTypeFormRenderer';
